import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './contact.css';
import { useTranslation } from 'react-i18next';

const Contact = (props) => {
  const { t } = useTranslation();
  return (
    <div className='contact10-container thq-section-padding'>
      <div className='contact10-max-width thq-section-max-width'>
        <div className='contact10-content1 thq-flex-row'>
          <div className='contact10-content2 flex-container'>
            <div className='contact10-left-box'>
              <h2 className='thq-heading-2'>
                {props.heading1 ?? (
                  <Fragment>
                    <span className='contact10-text5'>{t('contact.heading')}</span>
                  </Fragment>
                )}
              </h2>
              <p className='thq-body-large'>
                {props.content1 ?? (
                  <Fragment>
                    <span className='contact10-text6'>{t('contact.content')}</span>
                  </Fragment>
                )}
              </p>
            </div>
            <div className='flex'>
              <a
                href='https://wa.me/818074115851?text=I%27m%20interested%20in%20Application%20Assistance'
                target='_blank'
                rel='noreferrer noopener'
                className='contact10-link thq-button-filled justify-right'
              >
                <span>
                  {props.action1 ?? (
                    <Fragment>
                      <span className='contact10-text4'>{t('contact.action')}</span>
                    </Fragment>
                  )}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Contact.defaultProps = {
  action1: undefined,
  heading1: undefined,
  content1: undefined,
};

Contact.propTypes = {
  action1: PropTypes.element,
  heading1: PropTypes.element,
  content1: PropTypes.element,
};

export default Contact;
